import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

const EnvioSectionBand = ({
  title,
  count,
  countColor,
  tone = "docs",
  children,
  onClick,
  onMouseDown,
}) => {
  const theme = useTheme();
  const accent =
    tone === "pedidos" ? theme.palette.info.main : theme.palette.primary.main;

  return (
    <Box
      onClick={onClick}
      onMouseDown={onMouseDown}
      sx={{
        width: "100%",
        minWidth: 0,
        flex: "1 1 100%",
        boxSizing: "border-box",
        borderRadius: 2,
        border: "1px solid",
        borderColor: alpha(accent, 0.22),
        borderLeft: "3px solid",
        borderLeftColor: accent,
        backgroundColor: alpha(
          accent,
          theme.palette.mode === "dark" ? 0.1 : 0.045,
        ),
        px: 1.5,
        py: 1.2,
      }}
    >
      <Stack
        direction="row"
        spacing={0.75}
        alignItems="baseline"
        sx={{ mb: 1 }}
      >
        <Typography
          variant="caption"
          sx={{
            color: "text.secondary",
            fontWeight: 800,
            letterSpacing: 0.4,
            textTransform: "uppercase",
          }}
        >
          {title}
        </Typography>
        {count != null && count !== "" ? (
          <Typography
            variant="caption"
            sx={{
              fontWeight: 800,
              color: countColor || "text.secondary",
            }}
          >
            {count}
          </Typography>
        ) : null}
      </Stack>
      {children}
    </Box>
  );
};

export default EnvioSectionBand;
